<!--  -->
<template>
  <div class="child-box">
    <div class="child-head">
      <div class="child-name">设备状态</div>
    </div>
    <div class="content">
      <div class="head">
        <div class="head-item" style="text-align:left">设备名称</div>
        <div class="head-item">正常状态</div>
        <div class="head-item" style="text-align:right">异常状态</div>
      </div>
      <div class="table" v-for="(item,i) in basedata" :key="i">
        <div class="table-item" style="text-align:left">{{item.name}}</div>
        <div class="table-item">{{item.normal}}</div>
        <div class="table-item" style="text-align:right;width:26%">{{item.abnormal}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      basedata: [
        {
          name: "监控系统",
          normal: 123,
          abnormal: 12
        },
        {
          name: "火灾报警系统",
          normal: 124,
          abnormal: 13
        },
        {
          name: "消防供水系统",
          normal: 125,
          abnormal: 14
        },
        {
          name: "灭火系统",
          normal: 126,
          abnormal: 15
        },
        {
          name: "排水系统",
          normal: 127,
          abnormal: 16
        }
      ]
    };
  },

  components: {},

  computed: {},

  methods: {}
};
</script>
<style lang="less" scoped>
.content {
  width: 80%;
  height: 75%;
  margin-top: 7%;
  //   background: red;
  margin-left: 10%;
  .head {
    color: #066acd;
    font-size: 10px;
    width: 100%;
    height: 5%;
    display: flex;
    .head-item {
      width: 33%;
      text-align: center;
    }
  }
  .table {
    width: 100%;
    height: 2vh;
    background: url(../assets/table-item.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    margin-top: 1.86vh;
    display: flex;
    align-items: center;
    color: #bcdeff;
    font-size: 10px;
    .table-item {
      width: 33%;
      text-align: center;
    }
  }
}
</style>